module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rd-page"
  }, [_c('container', [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Runner Data")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Review runner profile, private notes, best records, tags and past sessions")])]), _vm._v(" "), _c('router-link', {
    staticClass: "rd-runmetrix-link",
    attrs: {
      "to": {
        name: 'runner-data',
        params: {
          runnerId: this.$props.runnerId
        },
        query: {
          runmetrix: 1
        }
      },
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 3v18h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 15l4-4 3 3 5-7"
    }
  })]), _vm._v("\n        Runmetrix\n      ")])], 1), _vm._v(" "), (_vm.runnerLoading) ? _c('div', {
    staticClass: "rd-dashboard"
  }, [_c('div', {
    staticClass: "rd-card rd-profile-card"
  }, [_c('div', {
    staticClass: "rd-profile-loading sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "rd-sk-line rd-sk-line--wide sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "rd-sk-line sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "rd-sk-line sk-shimmer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rd-card rd-detail-card"
  }, _vm._l((10), function(n) {
    return _c('div', {
      key: 'detail-sk-' + n,
      staticClass: "rd-sk-row"
    }, [_c('div', {
      staticClass: "rd-sk-label sk-shimmer"
    }), _vm._v(" "), _c('div', {
      staticClass: "rd-sk-value sk-shimmer"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rd-card rd-best-card"
  }, [_c('div', {
    staticClass: "rd-sk-line rd-sk-line--wide sk-shimmer"
  }), _vm._v(" "), _vm._l((4), function(n) {
    return _c('div', {
      key: 'best-sk-' + n,
      staticClass: "rd-best-skeleton sk-shimmer"
    })
  })], 2)]) : (_vm.$route.query.runmetrix == 1) ? _c('div', [_c('run-metrix', {
    attrs: {
      "runmetrix": _vm.runmetrixData,
      "runnerId": this.$props.runnerId
    }
  })], 1) : _c('div', {
    staticClass: "rd-content"
  }, [_c('div', {
    staticClass: "rd-dashboard"
  }, [_c('section', {
    staticClass: "rd-card rd-profile-card"
  }, [_c('div', {
    staticClass: "rd-card-header"
  }, [_c('span', {
    staticClass: "rd-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21a8 8 0 0 0-16 0"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rd-card-title"
  }, [_vm._v("Profile")]), _vm._v(" "), _c('p', {
    staticClass: "rd-card-sub"
  }, [_vm._v("Runner identity and confidential account data")])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-profile-top"
  }, [_c('div', {
    staticClass: "rd-profile-image-container"
  }, [(_vm.runner.imageUrl) ? _c('img', {
    staticClass: "rd-profile-image",
    attrs: {
      "src": _vm.runner.imageUrl,
      "alt": "Profile"
    }
  }) : _c('div', {
    staticClass: "rd-profile-placeholder"
  }, [_c('svg', {
    staticClass: "rd-profile-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "rd-runner-name"
  }, [_vm._v(_vm._s(_vm.runner.runner ? _vm.runner.runner.firstName : '-'))]), _vm._v(" "), _c('div', {
    staticClass: "rd-runner-id"
  }, [_vm._v("ID " + _vm._s(_vm.runner.runner ? _vm.runner.runner.id : _vm.runnerId))])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-confidential"
  }, [_c('div', {
    staticClass: "rd-confidential-label"
  }, [_vm._v("Confidential")]), _vm._v(" "), _c('div', {
    staticClass: "rd-private-row"
  }, [_c('span', [_vm._v("Mail address")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.runner.runner && _vm.runner.runner.user ? _vm.runner.runner.user.email : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-private-row"
  }, [_c('span', [_vm._v("Height")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.runner.runner ? _vm.runner.runner.height : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-private-row"
  }, [_c('span', [_vm._v("Weight")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.runner.runner ? _vm.runner.runner.weight : '-'))])]), _vm._v(" "), _c('button', {
    staticClass: "rd-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openEmailEditModal()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4h16v16H4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 6l-10 7L2 6"
    }
  })]), _vm._v("\n              Edit Email\n            ")])]), _vm._v(" "), (_vm.runner.runner) ? _c('div', {
    staticClass: "rd-edit-block"
  }, [_c('div', {
    staticClass: "rd-block-label"
  }, [_vm._v("Catchphrase")]), _vm._v(" "), (!_vm.editingCatchPhrase) ? _c('div', {
    staticClass: "rd-field-display"
  }, [_c('span', {
    staticClass: "rd-field-value"
  }, [_vm._v(_vm._s(_vm.runner.runner.catchPhrase || 'No catchphrase set'))]), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn",
    attrs: {
      "type": "button",
      "title": "Edit catchphrase"
    },
    on: {
      "click": function($event) {
        return _vm.startEditCatchPhrase()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])])]) : _c('div', {
    staticClass: "rd-field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.runner.runner.catchPhrase),
      expression: "runner.runner.catchPhrase"
    }],
    staticClass: "rd-textarea rd-textarea--small",
    attrs: {
      "maxlength": "255",
      "name": "catchPhrase",
      "placeholder": "Enter catchphrase"
    },
    domProps: {
      "value": (_vm.runner.runner.catchPhrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.runner.runner, "catchPhrase", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn rd-icon-btn--save",
    attrs: {
      "type": "button",
      "title": "Save catchphrase"
    },
    on: {
      "click": function($event) {
        return _vm.saveCatchPhrase()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('edit-email', {
    attrs: {
      "runner": _vm.runner,
      "show": _vm.showEmailModal
    },
    on: {
      "saved": _vm.onSavedEmail,
      "closed": _vm.onClosed
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "rd-card rd-detail-card"
  }, [_c('div', {
    staticClass: "rd-card-header"
  }, [_c('span', {
    staticClass: "rd-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 12h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 18h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rd-card-title"
  }, [_vm._v("Runner Summary")]), _vm._v(" "), _c('p', {
    staticClass: "rd-card-sub"
  }, [_vm._v("Core metadata and activity counters")])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-grid"
  }, [_c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Gender")]), _c('strong', [_vm._v(_vm._s(_vm.runner.runner ? _vm.runner.runner.gender : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Location")]), _c('strong', [_vm._v(_vm._s(_vm.runner.runner ? _vm.runner.runner.lastName : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item rd-detail-item--wide"
  }, [_c('span', [_vm._v("URL")]), _vm._v(" "), (_vm.runner.runner && _vm.runner.runner.website) ? _c('a', {
    staticClass: "rd-link",
    attrs: {
      "href": _vm.runner.runner.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.runner.runner.website))]) : _c('strong', [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Total km")]), _c('strong', [_vm._v(_vm._s(_vm.runner.totalDistance || '0 Km'))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Last Run")]), _c('strong', [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Days since last Run")]), _c('strong', [_vm._v(_vm._s(_vm.runner.daysSinceLastClass))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Last 30 days Best Rank")]), _c('strong', [_vm._v(_vm._s(_vm.runner.bestPlaceCurrentMonth))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Completed sessions")]), _c('strong', [_vm._v(_vm._s(_vm.runner.totalRuns))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-detail-item"
  }, [_c('span', [_vm._v("Account created")]), _c('strong', [_vm._v(_vm._s(_vm.createdOn || '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-medal-row"
  }, [_c('span', {
    staticClass: "rd-medal-pill"
  }, [_vm._v("Gold " + _vm._s(_vm.Gold))]), _vm._v(" "), _c('span', {
    staticClass: "rd-medal-pill"
  }, [_vm._v("Silver " + _vm._s(_vm.Silver))]), _vm._v(" "), _c('span', {
    staticClass: "rd-medal-pill"
  }, [_vm._v("Bronze " + _vm._s(_vm.Bronze))])]), _vm._v(" "), _c('div', {
    staticClass: "rd-activity-grid"
  }, [_c('div', [_c('span', [_vm._v("ラン・ウォーク")]), _c('strong', [_vm._v(_vm._s(_vm.runner.totalRuns))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("筋トレ")]), _c('strong', [_vm._v(_vm._s(_vm.runner.totalCountIndoorTraining))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("ストレッチ")]), _c('strong', [_vm._v(_vm._s(_vm.runner.totalCountStretch))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("ヨガ")]), _c('strong', [_vm._v(_vm._s(_vm.runner.totalCountYoga))])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-edit-block"
  }, [_c('div', {
    staticClass: "rd-block-label"
  }, [_vm._v("Profile")]), _vm._v(" "), (!_vm.editingProfileText) ? _c('div', {
    staticClass: "rd-field-display"
  }, [_c('span', {
    staticClass: "rd-field-value"
  }, [_vm._v(_vm._s(_vm.profileTexts || 'No profile text set'))]), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn",
    attrs: {
      "type": "button",
      "title": "Edit profile text"
    },
    on: {
      "click": function($event) {
        return _vm.startEditProfileText()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])])]) : _c('div', {
    staticClass: "rd-field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileTextEdit),
      expression: "profileTextEdit"
    }],
    staticClass: "rd-textarea",
    attrs: {
      "maxlength": "500",
      "placeholder": "Enter profile text"
    },
    domProps: {
      "value": (_vm.profileTextEdit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profileTextEdit = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn rd-icon-btn--save",
    attrs: {
      "type": "button",
      "title": "Save profile text"
    },
    on: {
      "click": function($event) {
        return _vm.saveProfileText()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])])])])]), _vm._v(" "), _c('section', {
    staticClass: "rd-card rd-best-card"
  }, [_c('div', {
    staticClass: "rd-card-header"
  }, [_c('span', {
    staticClass: "rd-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 3v18h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 14l3-3 4 4 5-8"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rd-card-title"
  }, [_vm._v("Best Records")]), _vm._v(" "), _c('p', {
    staticClass: "rd-card-sub"
  }, [_vm._v("Current year compared with all-time performance")])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-best-table"
  }, [_c('div', {
    staticClass: "rd-best-head"
  }, [_c('span', [_vm._v("Duration")]), _vm._v(" "), _c('span', [_vm._v("Best " + _vm._s(_vm.currentYear))]), _vm._v(" "), _c('span', [_vm._v("All time")])]), _vm._v(" "), _vm._l(([20, 30, 40, 60]), function(duration) {
    return _c('div', {
      key: 'duration-' + duration,
      staticClass: "rd-best-row"
    }, [_c('div', {
      staticClass: "rd-best-duration"
    }, [_vm._v(_vm._s(duration) + " min")]), _vm._v(" "), _c('div', {
      staticClass: "rd-best-cell"
    }, [(_vm.currentYearbest[duration] && _vm.currentYearbest[duration].length) ? _c('div', _vm._l((_vm.currentYearbest[duration]), function(bestRecord) {
      return _c('div', {
        key: 'year-' + duration + '-' + bestRecord.id,
        staticClass: "rd-record-line"
      }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(bestRecord.raceResume.finishDate))))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s((bestRecord.distance / 1000).toFixed(2)) + " km")])])
    }), 0) : _c('span', {
      staticClass: "rd-muted"
    }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
      staticClass: "rd-best-cell rd-best-cell--highlight"
    }, [(_vm.best[duration] && _vm.best[duration].length) ? _c('div', _vm._l((_vm.best[duration]), function(bestRecord) {
      return _c('div', {
        key: 'all-' + duration + '-' + bestRecord.id,
        staticClass: "rd-record-line"
      }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(bestRecord.raceResume.finishDate))))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s((bestRecord.distance / 1000).toFixed(2)) + " km")])])
    }), 0) : _c('span', {
      staticClass: "rd-muted"
    }, [_vm._v("-")])])])
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "rd-card rd-notes-card"
  }, [_c('div', {
    staticClass: "rd-card-header"
  }, [_c('span', {
    staticClass: "rd-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 2v6h6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 13H8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 17H8"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rd-card-title"
  }, [_vm._v("Notes & Tags")]), _vm._v(" "), _c('p', {
    staticClass: "rd-card-sub"
  }, [_vm._v("Internal memo fields and runner segmentation controls")])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-notes-grid"
  }, [_c('div', {
    staticClass: "rd-edit-block"
  }, [_c('div', {
    staticClass: "rd-block-label"
  }, [_vm._v("Memo")]), _vm._v(" "), (!_vm.editingMemo) ? _c('div', {
    staticClass: "rd-field-display"
  }, [_c('span', {
    staticClass: "rd-field-value"
  }, [_vm._v(_vm._s(_vm.memo || 'No memo set'))]), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn",
    attrs: {
      "type": "button",
      "title": "Edit memo"
    },
    on: {
      "click": function($event) {
        return _vm.startEditMemo()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])])]) : _c('div', {
    staticClass: "rd-field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memo),
      expression: "memo"
    }],
    staticClass: "rd-textarea rd-textarea--small",
    attrs: {
      "maxlength": "255",
      "name": "memo",
      "placeholder": "Enter memo"
    },
    domProps: {
      "value": (_vm.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn rd-icon-btn--save",
    attrs: {
      "type": "button",
      "title": "Save memo"
    },
    on: {
      "click": function($event) {
        return _vm.saveMemo()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-edit-block"
  }, [_c('div', {
    staticClass: "rd-block-label"
  }, [_vm._v("CM Memo")]), _vm._v(" "), (!_vm.editingCMMemo) ? _c('div', {
    staticClass: "rd-field-display"
  }, [_c('span', {
    staticClass: "rd-field-value"
  }, [_vm._v(_vm._s(_vm.cmmemo || 'No CM memo set'))]), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn",
    attrs: {
      "type": "button",
      "title": "Edit CM memo"
    },
    on: {
      "click": function($event) {
        return _vm.startEditCMMemo()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])])]) : _c('div', {
    staticClass: "rd-field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmmemo),
      expression: "cmmemo"
    }],
    staticClass: "rd-textarea rd-textarea--small",
    attrs: {
      "maxlength": "2000",
      "name": "cmmemo",
      "placeholder": "Enter CM memo"
    },
    domProps: {
      "value": (_vm.cmmemo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cmmemo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "rd-icon-btn rd-icon-btn--save",
    attrs: {
      "type": "button",
      "title": "Save CM memo"
    },
    on: {
      "click": function($event) {
        return _vm.saveCMMemo()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-tag-grid"
  }, [_c('div', {
    staticClass: "rd-tag-field runner-tags"
  }, [_c('p', {
    staticClass: "rd-tag-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.options,
      "multiple": "",
      "size": "1",
      "runnerid": this.$props.runnerId,
      "isRunnerTag": true,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rd-tag-field promocode-tags"
  }, [_c('p', {
    staticClass: "rd-tag-label"
  }, [_vm._v("Promo Code Tags")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.options,
      "multiple": "",
      "size": "1",
      "runnerid": this.$props.runnerId,
      "isPromoCodeTag": true,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selectedPromoTags),
      callback: function($$v) {
        _vm.selectedPromoTags = $$v
      },
      expression: "selectedPromoTags"
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "rd-card rd-runs-card"
  }, [_c('div', {
    staticClass: "rd-card-header rd-card-header--split"
  }, [_c('div', {
    staticClass: "rd-card-heading"
  }, [_c('span', {
    staticClass: "rd-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 12h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 18h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rd-card-title"
  }, [_vm._v("履歴 Past Runs")]), _vm._v(" "), _c('p', {
    staticClass: "rd-card-sub"
  }, [_vm._v("Session history, distances, route links and post-run responses")])])]), _vm._v(" "), _c('div', {
    staticClass: "rd-actions"
  }, [_c('button', {
    staticClass: "rd-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openAssignPromoCodeModal()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "7",
      "y1": "7",
      "x2": "7.01",
      "y2": "7"
    }
  })]), _vm._v("\n              Assign Promo Code\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "rd-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addRace()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14M5 12h14"
    }
  })]), _vm._v("\n              Add to Race\n            ")])])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "rd-table-skeleton"
  }, _vm._l((5), function(n) {
    return _c('div', {
      key: 'run-sk-' + n,
      staticClass: "rd-table-sk-row sk-shimmer"
    })
  }), 0) : _c('div', {
    staticClass: "rd-table-wrap"
  }, [_c('v-table', {
    attrs: {
      "is-horizontal-resize": "",
      "vertical-resize-offset": 60,
      "multiple-sort": false,
      "is-loading": _vm.isLoading,
      "even-bg-color": "#f8f8fb",
      "column-cell-class-name": _vm.columnCellClass,
      "columns": _vm.tableConfig.columns,
      "table-data": _vm.tableConfig.tableData,
      "paging-index": (_vm.pageIndex - 1) * _vm.pageSize
    },
    on: {
      "on-custom-comp": _vm.customCompFunc
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rd-pagination"
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1), _vm._v(" "), _c('edit-distance', {
    attrs: {
      "race": _vm.raceData,
      "show": _vm.showModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  }), _vm._v(" "), _c('add-race-data', {
    attrs: {
      "race": _vm.raceData,
      "runnerId": this.$props.runnerId,
      "show": _vm.showAddRaceModal
    },
    on: {
      "saved": _vm.onSavedRace,
      "closed": _vm.onClosed
    }
  }), _vm._v(" "), _c('assign-promo-code', {
    attrs: {
      "runnerId": this.$props.runnerId,
      "show": _vm.showAssignPromoCodeModal
    },
    on: {
      "saved": _vm.onSavedPromoCode,
      "closed": _vm.onClosed
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b790843"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RunnerData.vue
// module id = 1732
// module chunks = 2